import { useEffect } from 'react';
import { useHeader } from '../../Providers/HeaderContextProvider';
import arisLogo from '../../Assets/icon/aris_logo.svg';
import './AuthPages.css';

const GuidedPlanBlockPage = () => {
  const { setHeaderContent } = useHeader();

  useEffect(() => {
    setHeaderContent(false);
    
    return () => {
      setHeaderContent(true);
    };
  }, [setHeaderContent]);

  const handleViewPricing = () => {
    window.location.href = 'https://www.aris.ai/pricing.html';
  };

  return (
    <div className="auth-page-container">
      <div className="guided-plan-block-content">
        <img src={arisLogo} alt="Aris" className="auth-page-logo" />
        
        <h1 className="guided-plan-title">
          Web access to Aris is available<br />
          with a paid plan
        </h1>
        
        <p className="guided-plan-subtitle">
          You're currently using the Guided plan on mobile.<br />
          Upgrade your plan to continue on the web
        </p>

        <button 
          className="guided-plan-button"
          onClick={handleViewPricing}
        >
          View plans & pricing
        </button>

        <p className="auth-page-footer">© 2026 Aristotle, Inc. All rights reserved. Patents pending.</p>
      </div>
    </div>
  );
};

export default GuidedPlanBlockPage;
